import gql from 'graphql-tag';

export default gql`
  mutation mutateAddress(
    $street: String!
    $city: String!
    $state: String!
    $zipcode: String!
    $buildingName: String
    $label: String
    $id: Int
  ) {
    mutateAddress(
      street: $street
      city: $city
      state: $state
      zipcode: $zipcode
      buildingName: $buildingName
      label: $label
      id: $id
    ) {
      id
      lat
      lng
      street
      city
      state
      zipcode
      label
      buildingName
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/addresses/mutateAddressM.js